import { ArrowForwardIos, ContentCopy, Delete, Wifi } from "@mui/icons-material";
import React, { memo, useState } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

const COLOR = "#0f766e";
const BG = "#ccfbf1";

const HANDLES = [
  { id: "manutencao",       label: "Manutenção",        color: "#f59e0b", top: "34%" },
  { id: "chamado_existente",label: "Chamado existente",  color: "#3b82f6", top: "48%" },
  { id: "chamado_aberto",   label: "Chamado aberto",     color: "#22c55e", top: "62%" },
  { id: "resolvido",        label: "Resolvido",          color: "#8b5cf6", top: "76%" },
  { id: "erro",             label: "Erro",               color: "#ef4444", top: "90%" },
];

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "280px",
        maxWidth: "280px",
        width: "280px",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: `2px solid ${isHovered ? COLOR : "#e5e7eb"}`,
        boxShadow: isHovered ? `0 12px 32px rgba(15,118,110,.14)` : "0 4px 16px rgba(0,0,0,.06)",
        transition: "all 0.2s ease",
        transform: isHovered ? "translateY(-2px)" : "translateY(0)",
        userSelect: "none",
      }}
    >
      <Handle type="target" position="left"
        style={{ background: COLOR, width: 16, height: 16, left: -10, border: "3px solid #fff" }}
        isConnectable={isConnectable}>
        <ArrowForwardIos sx={{ color: "#fff", width: 8, height: 8, ml: "2.5px", mb: "0.5px", pointerEvents: "none" }} />
      </Handle>

      <div style={{ position: "absolute", right: 16, top: 16, display: "flex", gap: 8, opacity: isHovered ? 1 : 0, transition: "opacity .2s" }}>
        <div onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("duplicate"); }}
          style={{ width: 28, height: 28, borderRadius: 8, background: "#f3f4f6", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <ContentCopy sx={{ width: 14, height: 14, color: "#6b7280" }} />
        </div>
        <div onClick={() => { storageItems.setNodesStorage(id); storageItems.setAct("delete"); }}
          style={{ width: 28, height: 28, borderRadius: 8, background: "#fef2f2", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <Delete sx={{ width: 14, height: 14, color: "#ef4444" }} />
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", marginBottom: 16, paddingBottom: 12, borderBottom: "1px solid #f3f4f6" }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg, ${COLOR}, #0d9488)`, display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12, boxShadow: `0 4px 12px rgba(15,118,110,.25)`, flexShrink: 0 }}>
          <Wifi sx={{ width: 18, height: 18, color: "#fff" }} />
        </div>
        <div>
          <div style={{ color: "#111827", fontSize: 16, fontWeight: 700 }}>SGP — Diagnóstico</div>
          <div style={{ color: "#6b7280", fontSize: 12, fontWeight: 500 }}>Suporte de conexão autônomo</div>
        </div>
      </div>

      <div style={{ background: BG, padding: 12, borderRadius: 10, border: `1px solid #99f6e4`, marginBottom: 16 }}>
        <div style={{ fontSize: 11, color: "#134e4a", fontWeight: 600, marginBottom: 6 }}>Fluxo automático</div>
        {[
          "1. Solicita CPF",
          "2. Verifica manutenção na área",
          "3. Verifica chamados abertos",
          "4. Checklist guiado (power, wan, reinício)",
          "5. Abre chamado se necessário",
        ].map((step, i) => (
          <div key={i} style={{ fontSize: 11, color: COLOR, marginBottom: 2 }}>{step}</div>
        ))}
      </div>

      {HANDLES.map(h => (
        <React.Fragment key={h.id}>
          <Handle type="source" position="right" id={h.id}
            style={{ background: h.color, width: 16, height: 16, right: -10, top: h.top, border: "3px solid #fff" }}
            isConnectable={isConnectable}>
            <ArrowForwardIos sx={{ color: "#fff", width: 8, height: 8, ml: "2px", mb: "0.5px", pointerEvents: "none" }} />
          </Handle>
          <div style={{ position: "absolute", right: 20, top: `calc(${h.top} - 8px)`, fontSize: 10, fontWeight: 700, color: h.color, whiteSpace: "nowrap" }}>
            {h.label}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
});
